var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.77,
    height: 13,
    viewBox: "0 0 78.77 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(-110.23 -1120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(110.23 1123.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 38.063,
    height: 6.557,
    rx: 3.278,
    transform: "translate(21.955)",
    fill: "#40AEEE",
    opacity: 0.117
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 40.987,
    height: 6.557,
    rx: 3.278,
    fill: "#40AEEE"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$$",
    transform: "translate(174 1130)",
    fill: "#40AEEE",
    fontSize: 11,
    fontFamily: "Graphie-Bold, Graphie",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$$")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawdown);
export default __webpack_public_path__ + "static/media/drawdown.0625b468773fa32dac05d793ee894f5d.svg";
export { ForwardRef as ReactComponent };